import { apiDelete, apiGet, apiPost, apiPut } from './http'
import { downloadBlobResponse, normalizeBuildingQuery } from './helpers'

export const findAll = async (params = {}) =>
  apiGet('/income', {
    auth: true,
    config: { params: normalizeBuildingQuery(params) },
    fallbackMessage: 'Error al obtener los ingresos.',
  })

export const findById = async id =>
  apiGet(`/income/${id}`, {
    auth: true,
    fallbackMessage: 'Error al obtener el ingreso.',
  })

export const create = async payload =>
  apiPost('/income', payload, {
    auth: true,
    fallbackMessage: 'Error al crear el ingreso.',
  })

export const update = async ({ id, ...payload }) =>
  apiPut(`/income/${id}`, payload, {
    auth: true,
    fallbackMessage: 'Error al actualizar el ingreso.',
  })

export const remove = async id =>
  apiDelete(`/income/${id}`, {
    auth: true,
    fallbackMessage: 'Error al eliminar el ingreso.',
  })

export const exportExcel = async (params = {}) => {
  const response = await apiGet('/income/export/excel', {
    auth: true,
    rawResponse: true,
    config: {
      params: normalizeBuildingQuery(params),
      responseType: 'blob',
    },
    fallbackMessage: 'Error al exportar los ingresos a Excel.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, params.fileName || 'ingresos', 'xlsx')
  return { ok: true }
}

export const exportPdf = async (params = {}) => {
  const response = await apiGet('/income/export/pdf', {
    auth: true,
    rawResponse: true,
    config: {
      params: normalizeBuildingQuery(params),
      responseType: 'blob',
    },
    fallbackMessage: 'Error al exportar los ingresos a PDF.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, params.fileName || 'ingresos', 'pdf')
  return { ok: true }
}

export const notify = async payload =>
  apiPost('/income/notify', payload, {
    auth: true,
    fallbackMessage: 'Error al notificar los ingresos.',
  })
